import React, {type JSX} from 'react';
import {useIntl} from 'react-intl';
import {SPACE, Text, View} from '@lookiero/aurora';

import {capitalize} from '@helpers';

import {TEXT} from './PickupAddressBox.definition';

import {style} from './PickupAddressBox.styles';
import {PickupPoint} from '@domain/model/Account/PickupPoint/PickupPoint';

type PickupAddressBoxProps = {
  delivery: PickupPoint;
};

export const PickupAddressBox = ({delivery}: PickupAddressBoxProps): JSX.Element => {
  const {formatMessage} = useIntl();

  return (
    <View style={style.deliveryBox}>
      <Text action level={3} marginBottom={SPACE.SPACE_1}>
        {formatMessage(TEXT.TITLE)}
      </Text>
      <View>
        {delivery.pickupName && <Text level={3}>{capitalize(delivery.pickupName)}</Text>}
        <Text level={3}>{capitalize(delivery.address)}</Text>
        <Text level={3}>{capitalize(`${delivery.postCode}, ${delivery.city}`)}</Text>
      </View>
    </View>
  );
};
